import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
const Roadmap = ({}) => {
  const [platformTimeline, setPlatformTimeline] = useState([
    {
      title: "Invifo Founded",
      date: "January 2020",
      statusID: 3,
      description: `Founded in 2020 by Artha Pradyta & Aditya Prawira, Invifo is a
        multinational enterprise headquartered in Jakarta, Indonesia. The
        company founder's vision is to give anything that customer needs in a
        single platform and give them the best experiences and advantages by
        combining awesome technology like Artificial Intelligence, Machine
        Learning, Big Data, Robotic Process Automation, and the Internet of
        Things that help the customer easily and accurately take a decision for
        their business.`,
    },
    {
      title: "Invifo Core Platform Launched",
      date: "January 2023",
      statusID: 3,
      description: `After 3 years of massive development by the core teams, the platform reaches the first stable version. Most of the enterprise business process scenario from end-to-end has been covered from module CRM, Sales, Inventory, Procurement, and Finance. Many more useful features like Dashboards and Reports have been added also that make the users enjoy using the platform and give them insight into the company's health.`,
    },
    {
      title: "Invifo Portal Platform",
      date: "July 2024",
      statusID: 2,
      description:
        "Together with the Core Platform, Invifo customers will have a Portal Platform to manage their customers and vendors. This Portal Platform will have at least 3 major functions: Customer Portal, Vendor Portal, and Bidding Portal. This approach will significantly reduce the expense of A/P and A/R invoicing process. Many huge companies starts using this approach instead of investing huge costs in the automation of existing complicated processes. If the process can be made simpler, why not?",
    },
    {
      title: "Invifo Core Platform Enhancement",
      date: "January 2025",
      statusID: 1,
      description: `The Core Platform only is not enough. The platform will evolve continuously based on the new technology era, customer feedback, and customer needs. New modules will be added in this timeline like Production, Human Capital Management, and many more`,
    },
    {
      title: "Invifo B2B Market",
      date: "July 2025",
      statusID: 1,
      description: `This B2B Market ecosystem allows Invifo customers to publish their products or their requirements into the market. In this way, the companies can easily speed up their procurement process or otherwise make a huge chance of making a profit by selling the finished product, semi-finished product, or raw material. Not only that, there are more advantages to being a part of the Invifo B2B Market. If the deals happen, the Sales Order document will be created automatically on the seller's Core Platform system, otherwise, the Purchase Order document will be created automatically on the buyer's Core Platform system. Everything will be designed the best for Invifo customers.`,
    },
    {
      title: "Invifo Document Management System",
      date: "July 2026",
      statusID: 1,
      description: `Every company has to deal with a massive amount of documents. And entering this new era, everything must be digitized. The Invifo Document Management System allows the customers to manage the life cycle of the documents, from the documents captured, distributed amongst departments via workflow, until the documents are disposed or archived.`,
    },
    {
      title: "Invifo Core Artificial Intelligence",
      date: "January 2027",
      statusID: 1,
      description: `A system that only stores data is nothing, but a system that can give predictive analytics of the customer's business is something. The Invifo founders wants the platform to be smart enough to give advice based on data forecasting that helps customers easily and accurately take a decision during the business. That's why the combination of Big Data, Machine Learning, Artificial Intelligence, and the Internet of Things will play a big role to achieve this vision.`,
    },
  ]);
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Roadmap
      </Typography>
      <Typography paragraph variant="h5">
        A platform with continuous evolution.
      </Typography>
      <Typography paragraph variant="body1">
        The roadmap is a living document, and it is likely that priorities will
        change, but the list below should give some indication of our plans for
        the next major release, and for the future. This page is updated
        periodically so please revisit to monitor the progress.
      </Typography>
      <Timeline
        value={platformTimeline}
        align="alternate"
        content={(item) => {
          return (
            <Card title={item.title} subTitle={item.date}>
              <p>{item.description}</p>
            </Card>
          );
        }}
        marker={(item) => {
          if (item.statusID === 1) {
            return (
              <span className="custom-timeline-marker bg-warning">
                <i className="fas fa-clock"></i>
              </span>
            );
          } else if (item.statusID === 2) {
            return (
              <span className="custom-timeline-marker bg-primary">
                <i className="fas fa-play-circle"></i>
              </span>
            );
          } else if (item.statusID === 3) {
            return (
              <span className="custom-timeline-marker bg-success">
                <i className="fas fa-check-circle"></i>
              </span>
            );
          }
        }}
      />
    </React.Fragment>
  );
};

export default Roadmap;
